// extracted by mini-css-extract-plugin
export default {"dropdown":"DropdownMenu_dropdown__ElG3W","menu":"DropdownMenu_menu__XSKVr"};